var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cloudgroupcache-list',{attrs:{"id":"CloudgroupcacheListForCloudgroupSidepage","get-params":_vm.getParams,"is-owner":_vm.isOwner}})}
var staticRenderFns = []

export { render, staticRenderFns }